const selectors_1 = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors_1.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors_1.addressContainer),
      toggleButtons: document.querySelectorAll(selectors_1.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors_1.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors_1.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors_1.addressCountrySelect)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors_1.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    )
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}


// Custom Scripts
const tabHeads = document.querySelectorAll(".js-tab-head");
const tabContents = document.querySelectorAll("[data-tab-info]");

if (localStorage.getItem("tabId")) {
  tabHeads.forEach(function (tabHead) {
    tabHead.classList.remove("tab-active");
  });
  tabContents.forEach(function (tabContent) {
    tabContent.classList.remove("active");
  })
  document.querySelector(`.js-tab-head[data-tab-value="${localStorage.getItem("tabId")}"]`).classList.add("tab-active");
  document.querySelector(`${localStorage.getItem("tabId")}[data-tab-info]`).classList.add("active");
  if(localStorage.getItem("tabId") != "#addresses"){
  localStorage.removeItem("tabId");
  }
}




function _handleTabChange(e) {
  let tabId = e.currentTarget.getAttribute("data-tab-value");
  console.log('ihhh',tabId)
  localStorage.setItem("tabId", tabId);
  tabHeads.forEach(function (tabHead) {
    tabHead.classList.remove("tab-active");
  });
  tabContents.forEach(function (tabContent) {
    tabContent.classList.remove("active");
  })
  document.querySelector(`.js-tab-head[data-tab-value="${tabId}"]`).classList.add("tab-active");
  document.querySelector(`${tabId}[data-tab-info]`).classList.add("active");

}


if (tabHeads.length) {
  tabHeads.forEach(function (tabHead) {
    tabHead.addEventListener("click", _handleTabChange.bind(this), true);
  })
}